<template>
  <RouterView />
  <GlobalToastContainer />
  <PwaUpdatePrompt />
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user-store'
import GlobalToastContainer from '@/components/GlobalToastContainer.vue'
import PwaUpdatePrompt from '@/components/PwaUpdatePrompt.vue'

const userStore = useUserStore()
const route = useRoute()

/**
 * Aplica o tema do usuário em QUALQUER rota.
 *
 * Antes isso só acontecia em dois lugares: no boot do main.ts (que não roda de
 * novo depois do login, porque a navegação é SPA) e num watch dentro do
 * AppNavbarActions, que só existe quando há navbar. O destino do login é a
 * antessala (/hub), que não tem navbar — então quem acabou de entrar ficava
 * com o tema que a tela de login tivesse deixado no documento.
 *
 * As telas de autenticação são escuras por design e cuidam do próprio tema,
 * então ficam de fora.
 */
watch(
  [() => userStore.theme, () => route.path],
  ([theme, path]) => {
    if (String(path).startsWith('/auth')) return
    try {
      ;(window as unknown as { setAppTheme?: (t: string) => void }).setAppTheme?.(
        String(theme).toLowerCase() === 'dark' ? 'dark' : 'light',
      )
    } catch {
      /* tema é best-effort */
    }
  },
  { immediate: true },
)

onMounted(() => {
  const token = localStorage.getItem('authToken')
  // O boot em main.ts já busca /users/me antes do mount. Sem a guarda de `id`,
  // toda carga do app faz a mesma chamada duas vezes.
  if (token && !userStore.id) {
    userStore.fetchUserData()
  }
})
</script>

<style lang="scss">
@import 'scss/main.scss';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #931271;
}

body {
  margin: 0;
  min-width: 20rem;
}

.va-button__content {
  color: #ffffff !important;
}
</style>
